<div class="sa-container" (mouseenter)="onMouseEnterContainer()" (mouseleave)="onMouseLeaveContainer()">
  <button class="sa-trigger" id="btn-profile-trigger" (click)="toggleDropdown()">
    <span class="sa-avatar">
      <ion-icon name="person-circle-outline"></ion-icon>
    </span>

    <span class="sa-user-info" *ngIf="currentUser">
      <span class="sa-name" [title]="getUserName(currentUser)">{{ getUserName(currentUser) }}</span>
      <span class="sa-role" *ngIf="currentRole" [title]="currentRole.name">{{ currentRole.name }}</span>
    </span>

    <ion-icon name="chevron-down-outline" class="sa-chevron" [class.open]="showDropdown">
    </ion-icon>
  </button>

  <div class="sa-dropdown" *ngIf="showDropdown" (click)="$event.stopPropagation()">
    <!-- Profile Header -->
    <div class="sa-header">
      <div class="sa-header-main">
        <div class="sa-header-avatar">
          <ion-icon name="shield-checkmark"></ion-icon>
        </div>
        <div class="sa-header-info">
          <div class="sa-header-name">{{ getUserName(currentUser) }}</div>
          <div class="sa-header-email">{{ currentUser?.email }}</div>
        </div>
      </div>
      <div class="sa-active-badge" [title]="currentRole?.name || 'Active'">
        <span class="pulse-indicator"></span>
        {{ currentRole?.name || 'Active' }}
      </div>
    </div>

    <!-- Switch Account Section -->
    <div class="sa-section">
      <div class="sa-section-title">
        <ion-icon name="swap-horizontal-outline"></ion-icon>
        <span>Switch Role</span>
      </div>

      <div class="sa-loading" *ngIf="loadingAccounts">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <div class="sa-account-grid" *ngIf="!loadingAccounts">
        <button *ngFor="let acc of linkedAccounts" class="sa-acc-card"
          [class.active]="isCurrentAccount(acc)"
          [class.primary-account]="isPrimaryAccount(acc)"
          (click)="switchTo(acc)" [disabled]="switching">

          <div class="sa-acc-icon" [class.primary]="isPrimaryAccount(acc)">
            <ion-icon [name]="isPrimaryAccount(acc) ? 'shield-checkmark' : 'person'"></ion-icon>
          </div>
          <div class="sa-acc-details">
            <div class="sa-name-row">
              <span class="name">{{ getUserName(acc) }}</span>
              <span class="sa-primary-pill" *ngIf="isPrimaryAccount(acc)">Primary</span>
            </div>
            <div class="role" [title]="acc.display_role_name || acc.role?.name || acc.role_name || 'User'">{{ acc.display_role_name || acc.role?.name || acc.role_name || 'User' }}</div>
          </div>

          <ion-icon name="checkmark-circle" class="sa-status-icon" *ngIf="isCurrentAccount(acc)"></ion-icon>
          <ion-spinner name="dots" *ngIf="switching && !isCurrentAccount(acc)"></ion-spinner>
        </button>

      <div class="sa-empty" *ngIf="linkedAccounts.length <= 1 && !loadingAccounts">
          No other accounts linked.
        </div>
      </div>
    </div>

    <!-- Logout Section -->
    <!-- <div class="sa-footer">
      <button class="sa-logout-btn" (click)="logout()">
        <ion-icon name="log-out-outline"></ion-icon>
        <span>Log Out</span>
      </button>
    </div> -->
  </div>
</div>
